import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const TransactionLookup = withLazyFallback(
  () => import('components/admin/pages/TransactionLookup/TransactionLookup')
);

const ADMIN_TRANSACTIONS = [
  // {
  //   path: 'transactions',
  //   handle: { title: 'Transactions' },
  //   children: [
  //   ]
  // }
  { path: 'lookup', element: <TransactionLookup />, handle: { title: 'Transaction lookup' } }
];

export default ADMIN_TRANSACTIONS;
